module.exports = __webpack_public_path__ + "img/step02.a287cb9e.png";